import React, { useState, useEffect } from 'react';
import { FaUserCircle, FaSignOutAlt } from 'react-icons/fa';
import '../Css/Header.css';

const Header = ({ onLogedout, selectedOption, onOptionClick }) => {
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [role, setRole] = useState('');
  
  useEffect(() => {
    const userRole = localStorage.getItem('role');
    setRole(userRole);
  }, []);

  const handleLogout = () => {
    onLogedout();
  };

  const toggleDropdown = () => {
    setDropdownOpen(!isDropdownOpen);
  };

  return (
    <header className="header">
      <div className="header__logo-section">
        <div className="header__logo">Facturating</div>
      </div>

      <div className="header__navbar">

      { role !== 'User-reservation' && (
      <div className={`header__navbar-item ${selectedOption === 'option1-1' || selectedOption === 'option1-2' || selectedOption === 'option1-3' || selectedOption === 'option1-4' ? 'active' : ''}`}>
          Facturation
          <div className="header__dropdown">
            <div
              className={`header__dropdown-item ${selectedOption === 'option1-1' ? 'active' : ''}`}
              onClick={() => onOptionClick('option1-1')}
            >
              Ajouter Facture
            </div>
            <div
              className={`header__dropdown-item ${selectedOption === 'option1-2' ? 'active' : ''}`}
              onClick={() => onOptionClick('option1-2')}
            >
              Factures établies
            </div>
            <div
              className={`header__dropdown-item ${selectedOption === 'option1-3' ? 'active' : ''}`}
              onClick={() => onOptionClick('option1-3')}
            >
              Liste des résidents
            </div>
            <div
              className={`header__dropdown-item ${selectedOption === 'option1-4' ? 'active' : ''}`}
              onClick={() => onOptionClick('option1-4')}
            >
              Détail Factures
            </div>
          </div>
        </div>
        )}
        
        <div className={`header__navbar-item ${selectedOption === 'option2-1' || selectedOption === 'option2-2' ? 'active' : ''}`}>
          Reservation
          <div className="header__dropdown">
          { role !== 'User-facturation' && (
            <div
              className={`header__dropdown-item  ${selectedOption === 'option2-1' ? 'active' : ''}`}
              onClick={() => onOptionClick('option2-1')}
            >
              Ajouter réservation
            </div>
          )}

            <div
              className={`header__dropdown-item  ${selectedOption === 'option2-2' ? 'active' : ''}`}
              onClick={() => onOptionClick('option2-2')}
            >
              Consulter réservations
            </div>
          </div>
        </div>
        
        <div className={`header__navbar-item ${selectedOption === 'option3-1' || selectedOption === 'option3-2' ? 'active' : ''}`}>
          Documents acrvhivés
          <div className="header__dropdown">
            { role !== 'User-reservation' && (
            <div
              className={`header__dropdown-item`}
              onClick={() => onOptionClick('option3-1')}
            >
              Factures
            </div>
            )}
            
            <div
              className={`header__dropdown-item`}
              onClick={() => onOptionClick('option3-2')}
            >
              Réservations
            </div>

          </div>
        </div>

        <div className={`header__navbar-item ${selectedOption === 'option4-1' || selectedOption === 'option4-2' || selectedOption === 'option4-3' || selectedOption === 'option4-4' ? 'active' : ''}`}>
          Inventory
          <div className="header__dropdown">
            <div
              className={`header__dropdown-item ${selectedOption === 'option4-1' ? 'active' : ''}`}
              onClick={() => onOptionClick('option4-1')}
            >
              Ajouter Room
            </div>
            <div
              className={`header__dropdown-item ${selectedOption === 'option4-2' ? 'active' : ''}`}
              onClick={() => onOptionClick('option4-2')}
            >
              Ajouter Organisme
            </div>

            { role !== 'User-reservation' && (
            <div
              className={`header__dropdown-item ${selectedOption === 'option4-3' ? 'active' : ''}`}
              onClick={() => onOptionClick('option4-3')}
            >
              Ajouter hotels
            </div>
            )}

            { role !== 'User-reservation' && (
            <div
              className={`header__dropdown-item  ${selectedOption === 'option4-4' ? 'active' : ''}`}
              onClick={() => onOptionClick('option4-4')}
            >
              Ajouter type prix
            </div>
            )}

            <div
              className={`header__dropdown-item  ${selectedOption === 'option4-5' ? 'active' : ''}`}
              onClick={() => onOptionClick('option4-5')}
            >
              Importer Reservation
            </div>
          </div>
        </div>

        <div
          className={`header__navbar-item ${selectedOption === 'option5' ? 'active' : ''}`}
          onClick={() => onOptionClick('option5')}
        >
          Consulter client
        </div>

        {role !== 'User-facturation' && role !== 'User-reservation' && (
        <div
          className={`header__navbar-item ${selectedOption === 'option6' ? 'active' : ''}`}
          onClick={() => onOptionClick('option6')}
        >
          Gestion utilisateurs
        </div>
        )}

        {role !== 'User-facturation' && role !== 'User-reservation' && (
        <div
          className={`header__navbar-item ${selectedOption === 'option7' ? 'active' : ''}`}
          onClick={() => onOptionClick('option7')}
        >
          Dashboard
        </div>
        )}
      </div>

      <div className="header__profile">
        <div className="header__profile-circle" onClick={toggleDropdown}>
          <FaUserCircle className="header__profile-icon" />
        </div>
        {isDropdownOpen && (
          <div className="header__profile-dropdown">
            <button className="header__logout-btn" onClick={handleLogout}>
              <FaSignOutAlt /> Logout
            </button>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;